/* eslint-disable no-undef */
// eslint-disable-line import/imports-first
const Logger = require('@lmig/dotcom-utilities-helpers/logger');

require('isomorphic-fetch');

const logger = new Logger('client:helpers:isoApiCall');

module.exports = (url, options = {}) => {
  if (typeof window !== 'undefined') {
    logger.debug(`performing browser fetch to ${url}`);

    return fetch(url, options);
  }

  const PORT = process.env.PORT || 3000;

  // Only normalize requested URL when a relative path has been requested on the server
  let serverUrl;

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    serverUrl = `http://localhost:${PORT}${url}`;
  } else {
    serverUrl = url;
  }

  logger.debug(`performing server fetch to ${serverUrl}`);

  return fetch(serverUrl, options);
};
